const initialState = {
  initialRows: [],
  rows: [],
  query: '',
  sourceDataList: [],
  status: {
    isLoading: false,
  },
};

const configureDatasourcesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DATA_SOURCE_ADD_ROW':
      return {
        ...state,
        rows: [action.payload, ...state.rows],
        status: {
          ...state.status,
          hasChanges: true,
          hasEmptyFields: true,
        },
      };
    case 'DATA_SOURCE_DELETE_ROW':
      return {
        ...state,
        rows: state.rows.filter((row) => row.id !== action.payload),
        status: {
          ...state.status,
          hasChanges: true,
        },
      };
    case 'DATA_SOURCE_UPDATE_ROW':
      return {
        ...state,
        rows: state.rows.map((row) =>
          row.id === action.payload.rowId
            ? { ...row, [action.payload.key]: action.payload.value }
            : row
        ),
      };
    case 'DATA_SOURCE_IMPORT_ROWS':
      return {
        ...state,
        rows: action.payload,
        status: {
          ...state.status,
          hasChanges: true,
        },
      };
    case 'DATA_SOURCE_INITIAL_ROWS':
      return { ...state, initialRows: action.payload };

    case 'DATA_SOURCE_SET_ROWS':
      return { ...state, rows: action.payload };

    case 'DATA_SOURCE_DELETE_ROW_ID':
      return { ...state, deleteRowId: action.payload };

    case 'DATA_SOURCE':
      return { ...state, source: action.payload };

    case 'DATA_SOURCE_SET_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          ...action.payload,
        },
      };

    case 'DATA_SOURCE_SET_QUERY':
      return { ...state, query: action.payload };

    case 'DATA_SOURCE_LIST':
      return { ...state, sourceDataList: action.payload };

    default:
      return state;
  }
};

export default configureDatasourcesReducer;
